import TrainingReportLineChart from "./TrainingReportLineChart";

const COLORS = {
    primary: '#832BFB',
    secondary: '#4B68FF',
    accent: '#00C9A7'
}

const TrainingReportGraphView = ({ data }) => {
    const transformData = (data) => {
        // Combined Loss chart
        const lossData = [
            { x: [], y: [], mode: 'lines', name: 'Training Loss', line: { color: COLORS.primary } },
            { x: [], y: [], mode: 'lines', name: 'Validation Loss', line: { color: COLORS.secondary } }
        ]

        // Learning Rate chart
        const lrData = [
            { x: [], y: [], mode: 'lines', name: 'Learning Rate', line: { color: COLORS.primary } }
        ]

        // Time chart
        const timeData = [
            { x: [], y: [], mode: 'lines', name: 'Training Time', line: { color: COLORS.primary } },
            { x: [], y: [], mode: 'lines', name: 'Validation Time', line: { color: COLORS.secondary } }
        ]

        // Separated Metrics charts
        const trainingMetrics = [
            { x: [], y: [], mode: 'lines', name: 'Precision', line: { color: COLORS.primary } },
            { x: [], y: [], mode: 'lines', name: 'Recall', line: { color: COLORS.secondary } },
            { x: [], y: [], mode: 'lines', name: 'F-Score', line: { color: COLORS.accent } }
        ]
        const validationMetrics = [
            { x: [], y: [], mode: 'lines', name: 'Precision', line: { color: COLORS.primary } },
            { x: [], y: [], mode: 'lines', name: 'Recall', line: { color: COLORS.secondary } },
            { x: [], y: [], mode: 'lines', name: 'F-Score', line: { color: COLORS.accent } }
        ]

        data.forEach(e => {
            // Loss
            lossData[0].x.push(e.epoch)
            lossData[0].y.push(e.tr_loss)
            if (e.val_loss !== null) {
                lossData[1].x.push(e.epoch)
                lossData[1].y.push(e.val_loss)
            }

            // Learning Rate
            if (e.tr_lr != null) {
                lrData[0].x.push(e.epoch)
                lrData[0].y.push(e.tr_lr)
            }

            // Time
            if (e.tr_time != null) {
                timeData[0].x.push(e.epoch)
                timeData[0].y.push(e.tr_time)
            }
            if (e.val_time != null) {
                timeData[1].x.push(e.epoch)
                timeData[1].y.push(e.val_time)
            }

            // Training metrics
            trainingMetrics[0].x.push(e.epoch)
            trainingMetrics[0].y.push(e.tr_precision)
            trainingMetrics[1].x.push(e.epoch)
            trainingMetrics[1].y.push(e.tr_recall)
            trainingMetrics[2].x.push(e.epoch)
            trainingMetrics[2].y.push(e.tr_fscore)

            // Validation metrics
            if (e.val_precision !== null) {
                validationMetrics[0].x.push(e.epoch)
                validationMetrics[0].y.push(e.val_precision)
                validationMetrics[1].x.push(e.epoch)
                validationMetrics[1].y.push(e.val_recall)
                validationMetrics[2].x.push(e.epoch)
                validationMetrics[2].y.push(e.val_fscore)
            }
        })

        const hasValidation = lossData[1].x.length > 0
        const hasLr = lrData[0].x.length > 0
        const hasTime = timeData[0].x.length > 0

        return { lossData, lrData, timeData, trainingMetrics, validationMetrics, hasValidation, hasLr, hasTime }
    }

    const { lossData, lrData, timeData, trainingMetrics, validationMetrics, hasValidation, hasLr, hasTime } = transformData(data)

    const hasBothLrAndTime = hasLr && hasTime

    return data && (
        <div>
            <TrainingReportLineChart name="Loss" data={lossData} legendPosition="top-right" />
            {(hasLr || hasTime) && (
                <div className={`grid gap-4 mt-4 ${hasBothLrAndTime ? 'grid-cols-2' : 'grid-cols-1'}`}>
                    {hasLr && <TrainingReportLineChart name="Learning Rate" data={lrData} legendPosition="top-right" />}
                    {hasTime && <TrainingReportLineChart name="Time" data={timeData} legendPosition="top-right" />}
                </div>
            )}
            <div className="grid grid-cols-2 gap-4 mt-4">
                <div>
                    <TrainingReportLineChart name="Training Metrics (Precision & Recall & F-Score)" data={trainingMetrics} legendPosition="bottom-right" />
                </div>
                {hasValidation && (
                    <div>
                        <TrainingReportLineChart name="Validation Metrics (Precision & Recall & F-Score)" data={validationMetrics} legendPosition="bottom-right" />
                    </div>
                )}
            </div>
        </div>
    )
}

export default TrainingReportGraphView
